import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {Select} from '@ngxs/store';
import {AmbassadorDealershipsDto, AmbassadorState, AuthService} from 'remarketing-angular-library';
import {take} from 'rxjs/operators';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class AmbassadorGuard  {

  @Select(AmbassadorState.selectedAmbassadorDealership) selectedAmbassadorDealerShip$: Observable<AmbassadorDealershipsDto>;

  constructor(
    private readonly router: Router,
    private readonly authService: AuthService
  ) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise(resolve => {
      if (this.authService.isAmbassador()) {
        this.selectedAmbassadorDealerShip$.pipe(take(1)).subscribe(ambassadorSelectedDealership => {
          if (ambassadorSelectedDealership) {
            resolve(true);
          } else {
            this.authService.setPreviouslyRequestedRoute(state.url);
            this.router.navigate(['/ambassador-home']);
            resolve(false);
          }
        });
      } else {
        resolve(true);
      }
    });

  }
}
